module.exports = __webpack_public_path__ + "static/media/teygja_aftanverdlaeri.a6e23e54.png";